import { useEffect, useState } from "react"
import { useSelector } from "react-redux";
import ReactQuill from 'react-quill';
import sanitize from "helpers/sanitize";
import { useTranslation } from "translation/useTranslation";
import { Button } from "components/ui";

export default function SettingRemarksModal({ settingRemarks, handleSaveRemarks }) {
  const editorFormats = ['bold', 'italic', 'underline', 'bullet', 'list'];
  const editorModules = {
    toolbar: [
      ['bold', 'italic', 'underline', { 'list': 'bullet' }, { 'list': 'ordered' }]
    ]
  };

  const { editableTranslate } = useTranslation();

  const [id, setId] = useState(null);
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');

  const handleSave = () => {

    handleSaveRemarks(id, content);

    hideModal();
  }

  const showModal = () => {
    const modal = document.getElementById('remarksModal');
    modal.classList.add('show');
    modal.style.display = 'block';
  }

  const hideModal = () => {
    const modal = document.getElementById('remarksModal');
    modal.classList.remove('show');
    modal.style.display = 'none';
  }

  useEffect(() => {
    const listener = (e) => {
      if (e.target.dataset.id && e.target.dataset.action === 'open-remarks-modal') {
        const id = e.target.dataset.id;
        setId(id);
        setTitle(e.target.dataset.title);
        setContent(settingRemarks && settingRemarks[id] ? settingRemarks[id] : '');

        // show the modal
        showModal();

      } else if (e.target.dataset.dismiss === 'modal') {
        hideModal();
      }
    }

    document.addEventListener('click', listener);

    return () => {
      document.removeEventListener('click', listener);
    }
  }, [settingRemarks]);

  return <>
    {
      <>
        <div className={`modal release-notes-modal`} tabIndex="-1" id="remarksModal" aria-labelledby="remarksModalLabel" aria-hidden="true" data-testid="setting-remarks">
          <div className="modal-dialog modal-dialog-centered modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{editableTranslate('setting_remarks.title')}</h5>
              </div>
              <div className="modal-body">
                <div className="form-group">
                  <span>Remarks for: <strong><span dangerouslySetInnerHTML={{ __html: sanitize(title) }}></span></strong></span>
                </div>
                <div className="form-group" data-testid="setting-remarks-editor">
                  <ReactQuill theme="snow"
                    modules={editorModules} formats={editorFormats}
                    value={content} onChange={setContent}
                    style={{ height: '200px' }}
                  />
                </div>
              </div>
              <div className="modal-footer">
                <Button variant="secondary" data-dismiss="modal" data-testid="close-button">{editableTranslate('button.close')}</Button>
                <Button variant="primary" onClick={() => handleSave()} data-testid="save-button">{editableTranslate('button.save')}</Button>
              </div>
            </div>
          </div>
        </div>
      </>
    }
  </>
}
